import {moreCircleSvg as Icon__small__moreCircleSvg} from '../Icon__small/Icon__small--moreCircle.js';

export var moreCircle = {
  name: 'moreCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__moreCircleSvg,
};
